import { Component, Method, h, Element } from "@stencil/core"
import flatpickr from "flatpickr"
import "flatpickr/dist/l10n/de.js"
import "flatpickr/dist/l10n/fr.js"
import "flatpickr/dist/l10n/it.js"
import { Instance } from "flatpickr/dist/types/instance"
import { Options } from "flatpickr/dist/types/options"
import { getAppearance } from "../../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-input-datepicker",
  styleUrl: "input-datepicker.scss",
  shadow: true,
})
export class InputDatepicker {
  private componentEl?: HTMLDivElement

  @Element() public el!: HTMLSdxInputDatepickerElement

  @Method()
  public async updateFlatpickrInstance(
    flatpickrOptions: Options,
  ): Promise<Instance> {
    return flatpickr(this.componentEl!, flatpickrOptions)
  }

  public render() {
    return (
      <div
        class={{ [getAppearance(this.el)]: true }}
        ref={(el) => (this.componentEl = el)}
      />
    )
  }
}
